import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BOOKMARKS, PROFILE, ADD_CARD, ADD_BANK,BANK_ACCOUNT, MENUSETTINGS, HELP_SUPPORT, CONTACT_US, LOGIN, CHANNELS, MEMBERS } from '../../constants/routes';
import {
  CancelMenu,
  VerifiedIcon,
  MenuCard,
  MenuBank,
  MenuSupport,
  MenuLang,
  MenuLogout,
  MenuBookmarks,
  MenuSettings,
  MenuProfile,
  ContactUs,
} from '../Icons';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser, selectCreditCards } from '../../reducers/auth/auth.selectors';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Avatar from '../Avatar';
import { logoutUser } from 'reducers/auth/auth.actions';
import API from '../../API';
import { Dropdown } from 'react-bootstrap';
import { fetchProfileSubs } from 'reducers/profile/profile.actions';
import { selectIsFollowingProfile } from 'reducers/profile/profile.selectors';
import useComponentVisible from '../../utils/customHooks/useOutsideClick';

const BurgerMenu = ({ parentCallback, linkeProf, linkedProfile }) => {
  const user = useSelector(selectAuthUser);
  const isFollowingProfile = useSelector(selectIsFollowingProfile);
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [languagesData, setLanguagesData] = useState([]);
  const [sidebar, setSidebar] = useState(true);
  const [subscribeInfo, setSubscribeInfo] = useState({});
  const { t, i18n } = useTranslation();
  const isHebrew = localStorage.getItem('current_language') === 'he';
  const history = useHistory();

  const toggleMenu = () => {
    setSidebar(prevState => !prevState);
    parentCallback(sidebar);
    setIsOpen(prevState => !prevState);

    if (sidebar) {
      document.querySelector('html').style.height = `${window.innerHeight - 1}px`;
      document.body.style.top = `-${window.scrollY}px`
      document.body.style.position = 'fixed'
      document.body.style.overflow = "auto"
    }
    else {
      const scrollY = document.body.style.top
      document.querySelector('html').style.height = '';
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.overflow = ""
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
  };

  const { ref } = useComponentVisible(isOpen, () => toggleMenu());

  const logout = () => {
    dispatch(logoutUser()).then(resp => {
      history.push(LOGIN);
    });
    toggleMenu();
  };

  const languageChanger =
    (
      <div className="language-wrapper d-flex burger-link text-light-gray">
        <Dropdown>
          <Dropdown.Toggle>
            <MenuLang />
            {!!localStorage.getItem('current_language')
              ? t(
                Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language')) &&
                Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language'))
                  .name
              )
              : 'English'}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {Object.values(languagesData).map((language, index) => (
              <Dropdown.Item key={index} onClick={() => handleItemSelect(language)}>
                <label class="container" >
                  <input
                    type="radio"
                    checked={
                      Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language')) &&
                      Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language'))
                        .name === language.name
                    }
                    name="radio"
                  />
                  <span className="checkmark"></span>
                </label>
                <span className={'language-name'}> {t(language.name)}</span>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    )

  useEffect(() => {
    const fetchCountries = () => {
      API.get(`languages`).then(res => {
        setLanguagesData(res);
      });
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (!linkeProf) {
      dispatch(fetchProfileSubs(user.id))
        .then(res => {
          setSubscribeInfo(res);
        })
        .catch(err => {
          console.log('fetch user error', err);
        });
    }
  }, [isFollowingProfile]);

  const handleItemSelect = item => {
    let current_language = localStorage.getItem('current_language');
    if (current_language === item.id) return;
    if (item.id === 'he') {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    } else {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    }
    localStorage.setItem('current_language', item.id);
    i18n.changeLanguage(item.id.toLowerCase());
  };

  return !!user ? (
    <div ref={ref} className="burger-menu">
      <div className="menu-btn">
        <button
          className="avatar-button"
          onClick={e => {
            toggleMenu(e);
          }
          }
        >
          <Avatar
            className="cursor-pointer "
            user={user && user.name}
            size={24}
            image={user && user.avatar}
            style={{ border: 'unset', fontSize: '12px' }}
          />
        </button>
      </div>

      <div className={`menu-cont ${isOpen && 'opened'}`}>
        <div className="d-flex burger-user-header-container">
          <div className={' burger-user-header-link'}>
            <div className={' burger-user-link-cont'}>
              <Link to={PROFILE} onClick={toggleMenu}>
                <Avatar className="menu-avatar" user={user && user.name} size={48} image={user && user.avatar} />
              </Link>
              {user && <span className="menu-online-user active-artist"></span>}
            </div>
            <div className={'menu-avatar-wrap d-flex flex-column my-0 align-items-start'}>
              <div className={'menu-user-name-wrapper d-flex justify-content-center align-items-center'}>
                <div className={`menu-user-name ${isHebrew ? 'ml-1' : ' '} ${isHebrew ? 'mr-1' : ' '}`}>
                  {user && user.name}
                </div>
                {user.verification_status === 'verified' && (
                  <VerifiedIcon height="1rem" width="1rem" className={`fill-grey ml-1 header-icon-grey `} />
                )}
              </div>
              {user && user.nickname && (
                <span className={`menu-nickname ${isHebrew ? 'mr-1' : ' '}`}>@{user.nickname}</span>
              )}
              <div className="menu-sub-wrap">
                <Link className="d-flex sub-info-subscribing text-light-gray"
                  onClick={toggleMenu}
                  to={MEMBERS}
                >
                  <span>{subscribeInfo?.subscribers}</span>
                  <span>{t('members')}</span>
                </Link>
                <span className="subscribers-dot">.</span>
                <Link className="d-flex sub-info-subscribing text-light-gray"
                  onClick={toggleMenu}
                  to={CHANNELS}
                >
                  <span>{subscribeInfo?.subscribing}</span>
                  <span>{t('channels')}</span>
                </Link>
              </div>
            </div>

            <button className="btn cancel-menu-btn" onClick={toggleMenu}>
              <CancelMenu className={'header-icon-grey header-close-icon'} width={24} onClick={toggleMenu} />
            </button>
          </div>
        </div>

        <hr />
        <Link className="d-flex justify-content-between burger-link text-light-gray" onClick={toggleMenu} to={PROFILE}>
          <MenuProfile />
          <span>{t('My channel')}</span>
        </Link>
        <Link
          className="d-flex justify-content-between burger-link text-light-gray"
          onClick={toggleMenu}
          to={BOOKMARKS}
        >
          <MenuBookmarks />
          <span>{t('Bookmarks')}</span>
        </Link>
        <Link
          className="d-flex justify-content-between burger-link text-light-gray"
          onClick={toggleMenu}
          to={MENUSETTINGS}
        >
          <MenuSettings />
          <span>{t('Settings')}</span>
        </Link>

        <hr />
        <Link className="d-flex justify-content-between burger-link text-light-gray" onClick={toggleMenu} to={ADD_CARD}>
          <MenuCard />
          <span>{t('your_cards')}</span>
        </Link>
        <Link className="d-flex justify-content-between burger-link text-light-gray" onClick={toggleMenu} to={BANK_ACCOUNT}>
          <MenuBank />
          <span>{t('Bank details')}</span>
        </Link>

        <hr />
        <Link
          className="d-flex align-items-center justify-content-between burger-link text-light-gray"
          onClick={toggleMenu}
          to={CONTACT_US}
        >
          <ContactUs />
          <span>{t('contact_us')}</span>
        </Link>

        <Link
          className="d-flex justify-content-between burger-link text-light-gray"
          onClick={toggleMenu}
          to={HELP_SUPPORT}
        >
          <MenuSupport />
          <span>{t('Help and support')}</span>
        </Link>

        {languageChanger}

        <hr />
        <a
          className="burger-link text-light-gray cursor-pointer d-flex justify-content-between"
          onClick={logout}
          block={'true'}
        >
          <MenuLogout />

          {t('log_out')}
        </a>
      </div>
    </div>
  ) : (
    <div ref={ref} className="burger-menu">
      <div className="btn-cont">
        <div className="menu-btn">
          <button
            onClick={e => {
              toggleMenu(e);
            }}
          >
            <div className="linked-prof-menu"></div>
          </button>
        </div>
      </div>
      <div className={`menu-cont ${isOpen && 'opened'}`}>
        <div className="d-flex burger-user-header-container" style={{ height: '80px' }}>
          <div className={' burger-user-header-link'}>
            <div className={' burger-user-link-cont'}>
              <Link
                to={{
                  pathname: LOGIN,
                  state: { id: linkedProfile.id, nick: linkedProfile.nickname },
                }}
              >
                <div className="linked-prof-menu" style={{ width: '40px', height: '40px' }}></div>
              </Link>
            </div>
            <button className="btn cancel-menu-btn" onClick={toggleMenu}>
              <CancelMenu className={'header-icon-grey header-close-icon'} width={24} onClick={toggleMenu} />
            </button>
          </div>
        </div>

        <hr />

        {languageChanger}

        <hr />

        <Link
          className="burger-link text-light-gray cursor-pointer d-flex justify-content-between"
          to={{
            pathname: LOGIN,
            state: { id: linkedProfile.id, nick: linkedProfile.nickname },
          }}
        >
          <MenuLogout />

          <span> {t('Log in')}</span>
        </Link>
      </div>
    </div>
  );
};

export default BurgerMenu;
